import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { trackPortfolioLendPositionsViewed } from '../trackers/portfolio';

/**
 * Fires once per mount, the first time `active` turns true. Not re-armed
 * afterwards — a poll refresh changing the count is still the same impression.
 */
export const useTrackPortfolioLendPositionsViewed = t0 => {
  const $ = _c(4);
  const {
    active,
    positionCount
  } = t0;
  const trackedRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== active || $[1] !== positionCount) {
    t1 = () => {
      if (!active || trackedRef.current) {
        return;
      }
      trackedRef.current = true;
      trackPortfolioLendPositionsViewed({
        positionCount
      });
    };
    t2 = [active, positionCount];
    $[0] = active;
    $[1] = positionCount;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
};